import { useStyles } from './AliAuthImage.styles';

export const AliAuthImage = () => {
  const { classes } = useStyles();

  return <div className={classes.mock} />;
};
